import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesComponent {
  public readonly companies = [
    'A1',
    'dm',
    'flying-tiger',
    'penny-market',
    'orange',
    'nay',
    'o2',
    'coop',
    'tag-heuer',
    'tesco',
    'max-mara',
    'telekom',
    'intersport',
    'alltoys',
    'cbre',
    'telenor',
    'terno',
    'mango',
  ];
}
